import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';

import {
  PDF_GENERATING_KEYFRAMES,
  PdfGeneratingContainer,
  PdfGeneratingText,
  PdfSpinner,
} from './PrintDirectoryPage.style';

export interface PrintPdfGeneratorProps {
  isPdfGenerating: boolean;
  generatingPdfTitle: string;
  generatingPdfMessage: string;
}

export const PrintPdfGenerator = (props: PrintPdfGeneratorProps) => {
  const { isPdfGenerating, generatingPdfTitle, generatingPdfMessage } = props;
  if (!isPdfGenerating) return null;

  return (
    <>
      <style>{PDF_GENERATING_KEYFRAMES}</style>
      <ModalDialog
        data-testid="pdf-generating-modal"
        header={generatingPdfTitle || 'Generating PDF...'}
        hideClose={true}
        isOpen
      >
        <PdfGeneratingContainer>
          <PdfSpinner />
          <PdfGeneratingText>{generatingPdfMessage}</PdfGeneratingText>
        </PdfGeneratingContainer>
      </ModalDialog>
    </>
  );
};
